/**
 * Custom Judge.me modifications for product pages
 * - Moves the review header into the specific section-introduction
 * - Adds a custom click handler for the review button
 * - Extracts and displays review count and average rating
 * - Formats dates to use dots instead of slashes and reorders to day.month.year
 * - Customizes review badge text format
 */
document.addEventListener("DOMContentLoaded", function () {
  // Attendre que Judge.me soit complètement chargé
  const waitForJudgeMe = setInterval(function () {
    // Cibler spécifiquement la section avec l'ID unique
    const targetSection = document.querySelector(
      "#shopify-section-template--25090204926300__17450640935044aa3b",
    );

    if (!targetSection) {
      console.log("Section cible non trouvée, attente...");
      return;
    }

    // Trouver la section d'introduction spécifique dans cette section
    const sectionIntro = targetSection.querySelector(".section-introduction");
    const heading = sectionIntro
      ? sectionIntro.querySelector(".section-introduction__heading")
      : null;

    // Trouver l'en-tête Judge.me à déplacer
    const reviewHeader = document.querySelector(".jdgm-rev-widg__header");
    const formWrapper = document.querySelector(".jdgm-form-wrapper");

    // Modifier le texte du badge en haut de la page (une seule fois)
    updateBadgeText();

    if (reviewHeader && heading && formWrapper) {
      console.log("En-tête Judge.me trouvé, déplacement en cours...");
      clearInterval(waitForJudgeMe);

      // Extraire le nombre d'avis et la note moyenne
      const reviewCountElement = reviewHeader.querySelector(
        ".jdgm-rev-widg__summary-text",
      );
      const ratingElement = reviewHeader.querySelector(
        ".jdgm-rev-widg__summary-average",
      );

      let nb_reviews_custom = "0";
      let note_custom_moyenne = "0.00";

      if (reviewCountElement) {
        // Extraire le nombre d'avis (ex: "Basé sur 3 avis" -> "3")
        const reviewCountText = reviewCountElement.textContent;
        const reviewCountMatch = reviewCountText.match(/\d+/);
        if (reviewCountMatch) {
          nb_reviews_custom = reviewCountMatch[0];
        }
      }

      if (ratingElement) {
        // Extraire la note moyenne (ex: "5.00 sur 5" -> "5.00")
        const ratingText = ratingElement.textContent;
        const ratingMatch = ratingText.match(/(\d+\.\d+)/);
        if (ratingMatch) {
          note_custom_moyenne = ratingMatch[1];
        }
      }

      // Créer l'élément pour afficher les informations d'avis
      const reviewInfoElement = document.createElement("span");
      reviewInfoElement.className = "reviews_custom_by_fifi";
      reviewInfoElement.textContent = `( ${nb_reviews_custom} REVIEWS: ${note_custom_moyenne}/5 )`;
      reviewInfoElement.style.display = "block";
      reviewInfoElement.style.marginTop = "10px";
      reviewInfoElement.style.fontSize = "13px";
      reviewInfoElement.style.fontFamily = '"Founders Grotesk Mono", monospace';
      reviewInfoElement.style.textTransform = "uppercase";

      // Insérer l'élément après le titre
      heading.insertAdjacentElement("afterend", reviewInfoElement);

      // Créer un conteneur pour l'en-tête
      const reviewsContainer = document.createElement("div");
      reviewsContainer.className = "custom-reviews-container";
      reviewsContainer.style.textAlign = "center";
      reviewsContainer.style.marginTop = "15px";

      // Déplacer l'en-tête dans le nouveau conteneur
      reviewsContainer.appendChild(reviewHeader);

      // Insérer le conteneur après l'élément d'informations d'avis
      reviewInfoElement.insertAdjacentElement("afterend", reviewsContainer);

      // Trouver le bouton "Écrire un avis" dans l'en-tête déplacé
      const writeReviewButton = reviewsContainer.querySelector(
        ".jdgm-write-rev-link",
      );

      if (writeReviewButton) {
        // Remplacer le comportement par défaut du bouton
        writeReviewButton.addEventListener("click", function (e) {
          e.preventDefault(); // Empêcher le comportement par défaut

          // Afficher le formulaire d'avis
          formWrapper.style.display = "block";

          // Faire défiler la page jusqu'au formulaire
          formWrapper.scrollIntoView({ behavior: "smooth" });

          // Mettre à jour l'attribut aria-expanded
          this.setAttribute("aria-expanded", "true");
        });
      }

      console.log(
        "En-tête Judge.me déplacé avec succès et comportement du bouton modifié",
      );

      // Remplacer les slashes par des points dans les dates
      formatReviewDates();
    }
  }, 500);

  // Arrêter de vérifier après 10 secondes pour éviter une boucle infinie
  setTimeout(function () {
    clearInterval(waitForJudgeMe);
    console.log("Timeout: vérification terminée après 10 secondes");
  }, 10000);

  // Fonction pour formater les dates (remplacer les slashes par des points et réorganiser le format)
  function formatReviewDates() {
    // Observer les changements dans le DOM pour capturer les dates qui pourraient être chargées dynamiquement
    const observer = new MutationObserver(function (mutations) {
      const timestamps = document.querySelectorAll(".jdgm-rev__timestamp");
      timestamps.forEach(formatTimestamp);
    });

    // Observer le conteneur des avis pour détecter les changements
    const reviewsContainer = document.querySelector(".jdgm-rev-widg");
    if (reviewsContainer) {
      observer.observe(reviewsContainer, { childList: true, subtree: true });
    }

    // Formater les dates déjà présentes dans le DOM
    const timestamps = document.querySelectorAll(".jdgm-rev__timestamp");
    timestamps.forEach(formatTimestamp);

    // Fonction pour formater un élément timestamp individuel
    function formatTimestamp(timestamp) {
      const dateText = timestamp.textContent;
      if (dateText && dateText.includes("/")) {
        // Format original: MM/DD/YYYY (ex: 01/10/2025)
        const dateParts = dateText.split("/");
        if (dateParts.length === 3) {
          // Réorganiser en DD.MM.YYYY (jour.mois.année)
          const month = dateParts[0];
          const day = dateParts[1];
          const year = dateParts[2];
          timestamp.textContent = `${day}.${month}.${year}`;
        } else {
          // Si le format n'est pas celui attendu, juste remplacer les slashes par des points
          timestamp.textContent = dateText.replace(/\//g, ".");
        }
      }
    }
  }

  // Fonction pour modifier le texte des badges (sans observer les mutations)
  function updateBadgeText() {
    // Attendre un court instant pour s'assurer que les badges sont chargés
    setTimeout(function () {
      const badges = document.querySelectorAll(".jdgm-prev-badge__text");
      badges.forEach(function (badge) {
        const text = badge.textContent;
        const reviewCount = text.match(/\d+/);
        if (reviewCount) {
          badge.textContent = `REVIEWS ( ${reviewCount[0]} )`;
          badge.style.fontFamily = '"Founders Grotesk Mono", monospace';
          badge.style.textTransform = "uppercase";
          badge.style.letterSpacing = "1px";
        }
      });
    }, 1000);
  }
});
